import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/learn/spravato-vs-tms-for-depression")({
  beforeLoad: () => {
    throw redirect({
      to: "/learn/$slug",
      params: { slug: "saint-vs-spravato" },
    });
  },
});
